<template>
    <b-card no-body>
        <template v-slot:header>
            <div class="d-flex justify-content-end">
                <slot name="toolbar"></slot>
            </div>
        </template>

        <b-card-body v-if="false === isBusy && templates.length === 0">
            <b-alert variant="secondary" show>
              {{$t('email_templates.no_templates_found')}}
            </b-alert>
        </b-card-body>

        <b-card-body v-if="isBusy">
            <b-alert show variant="info">
                <fa-icon icon="spinner" class="mr-2" spin /> {{$t('email_templates.templates_downloading')}}</b-alert>
        </b-card-body>

        <b-list-group flush v-if="templates.length > 0">
            <b-list-group-item href="#" v-for="template in templates"
               :key="template.uuid"
               class="d-flex justify-content-between align-items-center"
               @click.prevent="selectTemplate(template.uuid)"
               :active="template.uuid === activeTemplateUuid"
               :disabled="isBusy"
            >
                {{ template.title }}
            </b-list-group-item>
        </b-list-group>

    </b-card>
</template>

<script>
import store from "../store/store";

export default {
    name: "TemplatesList",
    props: {
        isBusy: Boolean
    },
    computed: {
        ...store.mapState(['templates']),
        ...store.mapFields(['activeTemplateUuid'])
    },
    methods: {
        selectTemplate(uuid) {
            this.activeTemplateUuid = uuid;
        }
    }
}
</script>

<style lang="scss">
    .list-group.list-group-flush {
        margin: 0;
        padding: 0;
        .list-group-item {
            border-top: 1px solid rgba(0,0,0,.125) !important;
        }
    }
</style>